module.exports = __webpack_public_path__ + "img/3.2.f515ba42.png";